import { Subscription, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/blockable/blockable.decorator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * TODO: This decorator should be revised I think
 * @return {?}
 */
function Blockable() {
    return (/**
     * @param {?} target
     * @param {?} key
     * @param {?} descriptor
     * @return {?}
     */
    (target, key, descriptor) => {
        /** @type {?} */
        const method = descriptor.value;
        /** @type {?} */
        let isLoading = false;
        descriptor.value = (/**
         * @param {...?} args
         * @return {?}
         */
        function (...args) {
            if (isLoading) {
                return;
            }
            isLoading = true;
            /** @type {?} */
            const result = method.apply(this, args);
            switch (true) {
                case result instanceof Observable:
                    result.pipe(tap((/**
                     * @return {?}
                     */
                    () => isLoading = false), (/**
                     * @return {?}
                     */
                    () => isLoading = false)));
                    break;
                case result instanceof Promise:
                    result.then((/**
                     * @return {?}
                     */
                    () => isLoading = false), (/**
                     * @return {?}
                     */
                    () => isLoading = false));
                    break;
                case result instanceof Subscription:
                    result.add((/**
                     * @return {?}
                     */
                    () => isLoading = false));
                    break;
                default:
                    isLoading = false;
            }
            return result;
        });
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/unsubscribable/unsubscribable.decorator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function UnsubscribeOptions() { }
if (false) {
    /** @type {?} */
    UnsubscribeOptions.prototype.exclude;
}
/**
 * @param {?=} options
 * @return {?}
 */
function Unsubscribable(options = { exclude: [] }) {
    return (/**
     * @param {?} constructor
     * @return {?}
     */
    (constructor) => {
        /** @type {?} */
        const original = constructor.prototype.ngOnDestroy;
        constructor.prototype.ngOnDestroy = (/**
         * @return {?}
         */
        function () {
            for (const prop in this) {
                if (this.hasOwnProperty(prop)) {
                    /** @type {?} */
                    const property = this[prop];
                    if (!options.exclude.includes(prop)) {
                        if (property && (typeof property.unsubscribe === 'function')) {
                            property.unsubscribe();
                        }
                    }
                }
            }
            if (original && typeof original === 'function') {
                original.apply(this, arguments);
            }
        });
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/cacheable/cacheable.decorator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function CacheOptions() { }
if (false) {
    /** @type {?} */
    CacheOptions.prototype.lifetime;
}
/** @type {?} */
const DEFAULT_CACHE_OPTIONS = {
    lifetime: null
};
/**
 * @param {?=} options
 * @return {?}
 */
function Cacheable(options) {
    /** @type {?} */
    let cachedValue;
    /** @type {?} */
    let funcType;
    /** @type {?} */
    let inProgress = false;
    /** @type {?} */
    let result;
    return (/**
     * @param {?} target
     * @param {?} key
     * @param {?} descriptor
     * @return {?}
     */
    (target, key, descriptor) => {
        /** @type {?} */
        const method = descriptor.value;
        descriptor.value = (/**
         * @param {...?} args
         * @return {?}
         */
        function (...args) {
            if (typeof cachedValue !== 'undefined') {
                switch (funcType) {
                    case 'observable':
                        return of(cachedValue);
                    case 'promise':
                        return Promise.resolve(cachedValue);
                    default:
                        return cachedValue;
                }
            }
            if (inProgress) {
                return result;
            }
            inProgress = true;
            result = method.apply(this, args);
            switch (true) {
                case result instanceof Observable:
                    funcType = 'observable';
                    return result.pipe(tap((/**
                     * @param {?} val
                     * @return {?}
                     */
                    val => {
                        putCache(val);
                        inProgress = false;
                    })));
                case result instanceof Promise:
                    funcType = 'promise';
                    return result
                        .then((/**
                     * @param {?} value
                     * @return {?}
                     */
                    value => {
                        putCache(value);
                        inProgress = false;
                        return value;
                    }));
                default:
                    funcType = 'value';
                    putCache(result);
                    inProgress = false;
                    return result;
            }
        });
    });
    /**
     * @param {?} value
     * @return {?}
     */
    function putCache(value) {
        cachedValue = value;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/decorators.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DecoratorsModule {
}
DecoratorsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [],
                exports: []
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: agilie-angular-helpies-decorators.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { Blockable, Cacheable, DecoratorsModule, Unsubscribable };
